/**
 * "Happy to come in earlier if a slot opens" (B7, 8xat D08-09; diagram 08: a
 * checkbox set at booking by agents and anyone who books). It only sorts the
 * Sweeper's bring-forward rung — the client is called first when an earlier slot
 * opens with their artist. One tick for every booking surface.
 */
export default function PreferEarlierTick({
  checked,
  onChange,
  testid = 'prefer-brought-forward',
  className = 'mt-4',
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  testid?: string;
  className?: string;
}) {
  return (
    <label className={`${className} flex items-start gap-2.5 cursor-pointer`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testid}
        className="mt-0.5 accent-gold-bright"
      />
      <span>
        <span className="block font-inter text-sm text-cream">Happy to come in earlier if a slot opens</span>
        <span className="block font-serif text-[12px] text-cream-faint">
          We&rsquo;ll call first if an earlier time comes up with the same artist.
        </span>
      </span>
    </label>
  );
}
